import { useEffect, useState } from "react";
import { getCamelCaseWord } from "../static/brands_wholesalers_data";

const DropDownSelectFromList = ({ values = [], data, isNested, onValueSelect }) => {
  const [value, setValue] = useState("");
  const [list, setList] = useState([]);

  useEffect(() => {
    // Initialize the list based on data and values
    const updatedList = data?.filter((item) =>
      isNested
        ? !values?.find((v) => v?.id === item?.id)
        : item === "Men"
          ? !values?.find((v) => v.slice(0, v.indexOf("n") + 1) === item)
          : !values?.find((v) => v?.toLowerCase().includes(item?.toLowerCase()))
    );
    setList(updatedList);
  }, [data, values]);

  const _handleSelect = (event) => {
    const selectedValue = list.find((item) =>
      typeof item === "string"
        ? item === event.target.value
        : item?.label === event.target.value
    );
    if (selectedValue) {
      onValueSelect(selectedValue, values);
    }

    setValue(typeof selectedValue === 'string' ? selectedValue : selectedValue?.label)
  };
  return (
    <div style={{ maxWidth: "140px", margin: "10px auto" }}>
      <select
        className="form-select"
        onChange={_handleSelect}
        value={value}
        style={{
          borderRadius: "5px",
          fontSize: "14px",
        }}
      >
        <option value={value} disabled>
          {value}
        </option>
        {list.map((option, index) => (
          <option key={index} value={option?.label || option}>
            {getCamelCaseWord(option?.label || option)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDownSelectFromList;
